module.exports = __webpack_public_path__ + "img/nathan_live.12537f4a.jpeg";